import BaseService from './baseService';

export default class EnvironnementDeTravailService extends BaseService {
    getStructuresPaginated(lazyParams, cancelToken) {
        const queryParams = super.getQueryParams(super.getAPIPagedQuery(lazyParams))
        return this.axiosApiInstance.get(window.API_URL + `/api/EnvironnementDeTravail/GetStructuresPaginated?${queryParams}`, cancelToken)
          .then(res => res.data)
          .catch(err => super.handleHttpError(err));
      }
}